import { combineReducers } from 'redux';
import { WidgetType } from 'widgets/WidgetType';
import { buildSymbolTileConfigSlice } from 'widgets/symbolTile/store/instances/config/configslice';
import { SymbolTileWidgetInstanceState } from 'widgets/symbolTile/store/instances/SymbolTileWidgetInstanceState';
import { SymbolTileActionPayload } from 'widgets/symbolTile/store/instances/actions';
import { createWidgetsReducer } from 'widgets/store/widgetsReducerFactory';

const { reducer: configReducer } = buildSymbolTileConfigSlice();

const symbolWidgetInstanceReducer =
    combineReducers<SymbolTileWidgetInstanceState>({
        config: configReducer,
    });

export const symbolTileWidgetInstancesReducer = createWidgetsReducer<
    SymbolTileWidgetInstanceState,
    SymbolTileActionPayload
>(WidgetType.SYMBOL_TILE, symbolWidgetInstanceReducer);
